module.exports = __webpack_public_path__ + "img/Siempre Protegido.264fdd5b.svg";